import {
  REREGISTRATION_LOAD,
  REREGISTRATION_CLEAR,
} from '../actions/types';

const initialState = {
    modalOpen: false,
    successModalOpen: false,
    successMessage: '',
    showAcademicStatusTable: false,
    amount: '',
    showAmountError: false,
    buttonDisabled: false,
    buttonLabel: 'Continuer',
    showReRegistrationForm: false,
    isLoading: false,
    reRegistrationData: [],
    reRegistrationFormData: {},
    count: 0,
  };
  
  const reRegistrationReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case REREGISTRATION_LOAD:
        return { ...state, count: payload.count, reRegistrationData: payload.reRegistrations };
      case REREGISTRATION_CLEAR:
        return { ...state, reRegistrationData: [], count: 0 };
      case 'OPEN_MODAL':
        return { ...state, modalOpen: true };
      case 'CLOSE_MODAL':
        return { ...initialState};
      case 'SHOW_SUCCESS_MODAL':
        return {
           ...state, successModalOpen: true ,
           successMessage: action.payload || "Réinscription effectuée avec succès"};
      case 'HIDE_SUCCESS_MODAL':
        return { ...state, successModalOpen: false };
      case 'SET_SHOW_ACADEMIC_STATUS_TABLE':
        return { ...state, showAcademicStatusTable: action.payload };
      case 'SET_AMOUNT':
        return { ...state, amount: action.payload };
      case 'SET_AMOUNT_ERROR':
        return { ...state, showAmountError: action.payload };
      case 'SET_BUTTON_DISABLED':
        return { ...state, buttonDisabled: action.payload };
      case 'SET_BUTTON_LABEL':
        return { ...state, buttonLabel: action.payload };
      case 'SET_SHOW_RE_REGISTRATION_FORM':
        return { ...state, showReRegistrationForm: action.payload };
      case 'SET_RE_REGISTRATION_DATA':
        return { ...state, reRegistrationFormData: payload };
      case 'RESET_MODAL_STATE':
        return { ...initialState };
      default:
        return state;
    }
  };
  
  export default reRegistrationReducer;

  